<!-- Home component acts as an entry point that renders the dashboard component -->
<app-consumer-dashboard></app-consumer-dashboard>
